module.exports = __webpack_public_path__ + "static/media/IOL-blue.47623913.svg";